export const SET_TOKEN = "RECAPTCHA/SET_TOKEN"